import { Form, Grid, Modal } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CoachInfoResponse } from "../../../../hooks/Coach/data";
import { objectToQuerystring, pushGtag } from "../../../../plugins/utils";
import { steps as resultSteps } from "../../../Result/enumerations/steps";
import { FormParams } from "../../data";
import { step } from "../../enumerations/step";
import CoachCalendar from "../CoachCalendar";
import OtherFilter from "../OtherFilter";
import "./styles.scss";

const BookModal = ({
  open,
  setOpen,
  coachInfo,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
  coachInfo: CoachInfoResponse;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [form] = Form.useForm();
  const pathname = window.location.pathname.split("/");
  const coachId = [...pathname].pop();
  const [steps, setSteps] = useState<string>(step.OTHER);
  const [otherParams, setOtherParams] = useState<FormParams>();

  const stepsEnum: Record<string, any> = {
    [step.OTHER]: {
      handleOk: () => {
        const newOtherParams = form.getFieldsValue();
        delete newOtherParams.count;

        pushGtag({
          event: "book_coach_next_step",
          ...newOtherParams,
        });

        setOtherParams(newOtherParams);
        setSteps(step.DATE);
      },
      content: (
        <OtherFilter
          form={form}
          coachInfo={coachInfo}
          params={otherParams}
          setOpen={setOpen}
        />
      ),
    },
    [step.DATE]: {
      handleOk: () => {
        const dateParams = form.getFieldsValue();
        delete dateParams.date;
        const finalParams = {
          ...otherParams,
          ...dateParams,
          coach_account_id: coachId,
          coach_designated: 1,
        };
        console.debug("finalParams", finalParams);

        pushGtag({
          event: "book_coach_final",
          ...finalParams,
        });

        const queryString = objectToQuerystring(finalParams);
        navigate(`/search/?step=${resultSteps.SEARCH}&${queryString}`, {
          state: { nickname: coachInfo.nickname },
        });
      },
      content: (
        <CoachCalendar
          open={open}
          params={otherParams}
          form={form}
          setSteps={setSteps}
        />
      ),
    },
  };

  const handleCancel = () => {
    pushGtag({
      event: "book_coach_cancel",
    });

    setOpen(false);
  };

  useEffect(() => {
    if (!open) {
      setSteps(step.OTHER);
      setOtherParams(undefined);
    }
  }, [open]);

  return (
    <Modal
      closable={false}
      open={open}
      onCancel={handleCancel}
      width={430}
      destroyOnClose
      className="book-modal"
      footer={false}
      modalRender={(dom) => (
        <Form
          variant={"filled"}
          autoComplete={"off"}
          form={form}
          requiredMark={false}
          layout={"vertical"}
          onFinish={stepsEnum[steps].handleOk}
          clearOnDestroy
        >
          {dom}
        </Form>
      )}
    >
      {stepsEnum[steps].content}
    </Modal>
  );
};

export default BookModal;
